<div class="goal-item-container-mobile" fxShow fxHide.gt-xs>
  <mat-accordion>
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title class="goal-item-header-mobile">
            <span class="task-status-wrapper">
              <p class="task-status-overdue" *ngIf="overdueTasks > 0">
                  {{ overdueTasks }} {{"task over due" | translate}} 
              </p>
              <p class="task-status-on-track" *ngIf="!overdueTasks">
                {{ "On Track" | translate}} 
              </p>
              <button mat-icon-button 
                aria-label="More options button"
                (click)="onMoreButtonClick($event)"
                class="more-button"
                *ngIf="!goalsData.byStaff"
                [matMenuTriggerFor]="menu"
              >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onEditGoal()">
                {{"Edit" | translate}}
              </button>
            </mat-menu>
            </span>
            <p class="goal-name">{{ goalsData.name }}</p>
            
            <div class="progress-row">
              <mat-progress-bar mode="determinate" [value]="goalProgress"></mat-progress-bar>
              <p>{{'Goal due' | translate}}: {{ goalsData.due | date:'mediumDate' }}</p>
            </div>
            
          </mat-panel-title>

        </mat-expansion-panel-header>
        <mat-divider class="divider"></mat-divider>

        <div class="goals-items-content-container-mobile">

          <div class="goals-item-description-wrapper">
              <p class="goals-item-description-text">{{"Description" | translate }}{{":"}}</p>
              <p>{{ goalsData.description }}</p>
          </div>

          <div class="goals-items-task-container">
              <div class="goals-item-task-wrapper">
                  <div class="goals-item-task-header-wrapper">
                      <p class="tasks-header">{{ "Tasks" | translate}}</p>
                      <p class="due-date-header">{{ "Due date" | translate }}</p>
                  </div>
                  <mat-divider class="divider"></mat-divider>

                  <div class="goals-item-task-content-container" *ngFor="let task of goalsData.goalTasks">
                      <div class="goals-item-task-content-wrapper">
                          <mat-checkbox 
                            [checked]="task.isDone" 
                            [(ngModel)]="task.isDone" 
                            class="task-checkbox"
                            (change)="onChecked(task.goalTaskId, task.isDone)"
                          >
                            {{ task.name }}
                          </mat-checkbox>
                          <p>{{ task.due | date:'mediumDate' }}</p>
                      </div>
                      <mat-divider class="divider"></mat-divider>
                  </div>

              </div>

              <div class="goals-item-created-by-info">
                  <p><span class="info-header">{{ "Created by" | translate  }}:</span> {{ goalsData.createdByName }}</p>
                  <p><span class="info-header">{{ "Last edited by" | translate  }}:</span> {{ goalsData.updatedByName == "" ? "N/A" : goalsData.updatedByName }}</p>
                  <p><span class="info-header">{{ "Created on" | translate  }}:</span> {{ getDateFromEpoch(goalsData.createdDate) | date:'mediumDate'}}</p>
                  <p><span class="info-header">{{ "Last edit date" | translate  }}:</span> {{ getDateFromEpoch(goalsData.updatedDate) | date:'mediumDate' }}</p>
              </div>
          </div>
          
        </div>
        

      </mat-expansion-panel>
    </mat-accordion>
</div>


<!-- Start of Desktop View -->
<div class="goal-item-container" fxHide fxShow.gt-xs>
    <mat-accordion>
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title class="goal-item-header">
              <p>{{ goalsData.name }}</p>
              <span class="task-status-wrapper">
                <p class="task-status-overdue" *ngIf="overdueTasks > 0">
                    {{ overdueTasks }} {{"task over due" | translate}} 
                </p>
                <p class="task-status-on-track" *ngIf="!overdueTasks">
                  {{ "On Track" | translate}} 
              </p>
                </span>
                <span class="progress-bar">
                    <mat-progress-bar mode="determinate" [value]="goalProgress"></mat-progress-bar>
                </span>
              <p>{{ goalsData.due | date:'mediumDate' }}</p>
              <p>{{ goalsData.createdByName }}</p>
              <button mat-icon-button 
                  aria-label="More options button"
                  (click)="onMoreButtonClick($event)"
                  class="more-button"
                  *ngIf="!goalsData.byStaff"
                  [matMenuTriggerFor]="menu"
                >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onEditGoal()">
                  {{"Edit" | translate}}
                </button>
              </mat-menu>
            </mat-panel-title>

          </mat-expansion-panel-header>
          <mat-divider class="divider"></mat-divider>

          <div class="goals-items-content-container">

            <div class="goals-item-description-wrapper">
                <p class="goals-item-description-text">{{"Description" | translate }}{{":"}}</p>
                <p>{{ goalsData.description }}</p>
            </div>

            <div class="goals-items-task-container">
                <div class="goals-item-task-wrapper">
                    <div class="goals-item-task-header-wrapper">
                        <p class="tasks-header">{{ "Tasks" | translate}}</p>
                        <p class="due-date-header">{{ "Due date" | translate }}</p>
                    </div>
                    <mat-divider class="divider"></mat-divider>

                    <div class="goals-item-task-content-container" *ngFor="let task of goalsData.goalTasks">
                        <div class="goals-item-task-content-wrapper">
                            <mat-checkbox 
                              [checked]="task.isDone" 
                              [(ngModel)]="task.isDone" 
                              class="task-checkbox"
                              (change)="onChecked(task.goalTaskId, task.isDone)"
                            >
                              {{ task.name }}
                            </mat-checkbox>
                            <p>{{ task.due | date:'mediumDate' }}</p>
                        </div>
                        <mat-divider class="divider"></mat-divider>
                    </div>

                </div>

                <div class="goals-item-created-by-info">
                    <p><span class="info-header">{{ "Created by" | translate  }}:</span> {{ goalsData.createdByName }}</p>
                    <p><span class="info-header">{{ "Created on" | translate  }}:</span> {{ getDateFromEpoch(goalsData.createdDate) | date:'mediumDate'}}</p>
                    <p><span class="info-header">{{ "Last edited by" | translate  }}:</span> {{ goalsData.updatedByName == "" ? "N/A" : goalsData.updatedByName }}</p>
                    <p><span class="info-header">{{ "Last edit date" | translate  }}:</span> {{ getDateFromEpoch(goalsData.updatedDate) | date:'mediumDate' }}</p>
                </div>
            </div>
            
          </div>
          

        </mat-expansion-panel>
      </mat-accordion>
</div>
